import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { transactionHistory, withdrawableTransactions } from '../../Services/DashboardServices';

const columns = [
    { name: 'Order ID', selector: row => row.order_id, width: '15%' },
    { name: 'Amount', selector: row => row.amount, width: '10%' },
    { name: 'Withdrawable In', selector: row => row.withdrawable_in, width: '25%' },
    // { name: 'Withdrawable Days', selector: row => row.withdrawable_at_days },
    // { name: 'Payment Type', selector: row => row.payment_type },
    { name: 'Description', selector: row => row.description, width: '50%' },
    // { name: 'Status', selector: row => row.status },
];

const RefferalAndEarning = () => {
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleGetTransaction = async () => {
        setLoading(true);
        try {
            const response = await transactionHistory();
            setData(response?.result?.transactions?.original?.data || []);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching transaction history", err);
        }
    };


    useEffect(() => {
        handleGetTransaction();
    }, []);

    useEffect(() => {
        const filtered = data.filter(item =>
            Object.values(item).some(value =>
                String(value).toLowerCase().includes(filterText.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [filterText, data]);

    return (
        <div>


            <h3 className='fw-bold mb-0'>Refferal and Earning</h3>
            <p>
                All refferal and earnings
            </p>

            <div className='text-end'>
                <input
                    type="text"
                    placeholder="Search..."
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    style={{
                        marginBottom: '10px',
                        padding: '8px',
                        width: '300px',
                        borderRadius: '5px',
                        border: '1px solid #ccc'
                    }}
                />
            </div>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <div className="spinner-border text-info" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <DataTable
                    columns={columns}
                    data={filteredData}
                    pagination
                    highlightOnHover
                    striped
                />
            )}
        </div>
    );
};

export default RefferalAndEarning;
